import React, { Component } from 'react';
import IdleTimeoutService from "../../services/idle-timeout.service";

const ConfirmationBox = (data) => {

    //confirmation box
    return(
        <div>
            {data && data.title && <p className="fs-16">{data.title}</p>}
            {data.messages && data.messages.map((message,index)=>{
                return (
                    <p key ={index} className="fs-14 fs-light pb-10 pt-10 pull-left color-6-grey">{message}</p>
                )
            })}
            <p className="text-right">
            {data.buttons && data.buttons.map((button,index)=>{
                return(
                    <a  key={index} href="javascript:void(0)"
                       className={`pt-10 fs-14 mr-10 pl-20 uppercase 
                       ${(button.highlight ? 'color-link  ' :'color-dark-grey')}`
                    
                    }
                        onClick={()=>{
                            IdleTimeoutService.updateIdleState();
                            button.onClick()
                        }}
                    >{button.label}</a>
                )
            })}
            </p>
        </div>

    );
}

export default ConfirmationBox;


// WEBPACK FOOTER //
// ./src/components/common-components/confirmation-box.component.js